// Returns the style for a map element adapted to the current zoom level of the
// map
//
export default function dashArrayFor(styleName) {
  switch (styleName) {
    case "none":
      return "0 0";
    case "solid":
      return "1 1";
    case "dotted":
      return "1 10";
    case "dashed":
      return "10 14";
    default:
      return null;
  }
}
